import { useGenericSocket } from "@/hooks/useGenericSocket";
import { SocketTopics } from "@/lib/natsConnection";
import { useCallback } from "react";

export interface ITopGainersVolume {
  prc: string;
  quote: string;
}

export interface ITopGainersVolumeResponse {
  [timeframe: string]: {
    [symbol: string]: ITopGainersVolume;
  };
}

export interface ITopGainersVolumeRow {
  symbol: string;
  prc: string;
  quote: string;
}

export function useTopGainersVolume(timeframe: string) {
  const handler = useCallback(
    (_: ITopGainersVolumeRow[], newData: ITopGainersVolumeResponse) => {
      // convert ITopGainersVolumeResponse to ITopGainersVolumeRow
      const rows = Object.entries(newData[timeframe] || {}).map(
        ([symbol, value]) => ({
          symbol,
          prc: value.prc,
          quote: value.quote,
        }),
      );

      return rows as ITopGainersVolumeRow[];
    },
    [timeframe],
  );

  return useGenericSocket<ITopGainersVolumeRow[], ITopGainersVolumeResponse>(
    SocketTopics.topGainersVolumePrc,
    handler,
  );
}
